/**
 * Nature — Full Traceability. Frontend behaviour.
 *
 * Sequential blur-in (text block, then boxes); each box's lime bar fills
 * left→right on entrance and re-fills on hover. Skipped under
 * prefers-reduced-motion. Loaded as an ES module only where the block renders.
 */
import './style.scss';
import { gsap } from 'gsap';

function init() {
	const sections = document.querySelectorAll('[data-ftrace]');
	if (!sections.length) return;

	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	sections.forEach((section) => {
		const textEls = Array.from(section.querySelectorAll('[data-ftrace-anim]'));
		const boxes = Array.from(section.querySelectorAll('[data-ftrace-box]'));
		const bars = Array.from(section.querySelectorAll('[data-ftrace-bar]'));
		if (!textEls.length && !boxes.length) return;

		if (reduced) {
			[...textEls, ...boxes].forEach((el) => {
				el.style.opacity = '1';
				el.style.filter = 'none';
				el.style.transform = 'none';
			});
			return;
		}

		gsap.set(textEls, { opacity: 0, y: 20, filter: 'blur(10px)' });
		gsap.set(boxes, { opacity: 0, y: 28, filter: 'blur(12px)' });
		gsap.set(bars, { scaleX: 0 });

		const play = () => {
			const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

			tl.to(textEls, { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.7, stagger: 0.12 }, 0.1);
			// clearProps:transform so GSAP's leftover inline transform doesn't
			// override the CSS :hover lift (translateY).
			tl.to(boxes, { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.7, stagger: 0.12, clearProps: 'transform' }, 0.25);
			tl.to(bars, { scaleX: 1, duration: 0.6, ease: 'power2.out', stagger: 0.12 }, 0.45);
		};

		// Re-fill a box's bar on hover (same left→right sweep as entrance).
		boxes.forEach((box) => {
			const bar = box.querySelector('[data-ftrace-bar]');
			if (!bar) return;
			box.addEventListener('mouseenter', () => {
				gsap.fromTo(
					bar,
					{ scaleX: 0 },
					{ scaleX: 1, duration: 0.5, ease: 'power2.out', overwrite: true }
				);
			});
		});

		const io = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					io.unobserve(entry.target);
					play();
				});
			},
			{ rootMargin: '0px 0px -15% 0px', threshold: 0.1 }
		);
		io.observe(section);
	});
}

if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init);
